// Configuración de la aplicación
const config = {
  // URL base de la API
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  
  // URL base para autenticación
  AUTH_URL: process.env.REACT_APP_AUTH_URL || 'http://localhost:8000',
  
  // Tiempo de expiración del token en minutos (para mostrar alertas)
  TOKEN_EXPIRY_ALERT: 5,
  
  // Versión de la aplicación
  APP_VERSION: '1.0.0',
};

export default config; 